import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from "./ReportStyle";

const pageHeder = (doc, data) => {
    style.pageBorder(doc, data);
    style.pageHeder(doc, data);
    style.reportHeder1(doc, data);
};

// data = { Period, values, manual, details }
const CashBookReportPDF = (data) => {
    const doc = new jsPDF("p", "pt", "a4");
    pageHeder(doc, data);
    style.tableBody(doc, data);
    style.pageFooter(doc, data);
    doc.setProperties({ title: "CashBook Report" });

    const pdfUrl = URL.createObjectURL(doc.output("blob"));
    window.open(pdfUrl);
};

export default CashBookReportPDF;